import DecimalValueFormat from './DecimalValueFormat.jsx';

function AboveBelowFormat({value, unit, benchmark}) {
  if (value > benchmark.value) {
    return `${DecimalValueFormat({value: Math.abs(value - benchmark.value)})} ${unit} above ${benchmark.name}`;
  } else {
    return `${DecimalValueFormat({value: Math.abs(value - benchmark.value)})} ${unit} below ${benchmark.name}`;
  }
}

export default AboveBelowFormat
